import React from 'react';
import ReactPagination from 'react-paginate';
import styles from './Pagination.module.scss';

export const Pagination = props => (
    <ReactPagination activeClassName={styles.active} containerClassName={styles.container} {...props} />
);
